var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTileList = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M2.5 21.5V15H11v6.5H2.5zm10.5 0V11h8.5v10.5H13zM13 9V2.5h8.5V9H13zM2.5 13V2.5H11V13H2.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M15 19.5h4.5V13H15v6.5zm-10.5 0H9V17H4.5v2.5zM15 7h4.5V4.5H15V7zM4.5 11H9V4.5H4.5V11z"
}))));
export default SvgIconTileList;